import { render, staticRenderFns } from "./Endpage.vue?vue&type=template&id=0c1c0a63&scoped=true"
import script from "./Endpage.vue?vue&type=script&lang=js"
export * from "./Endpage.vue?vue&type=script&lang=js"
import style0 from "./Endpage.vue?vue&type=style&index=0&id=0c1c0a63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1c0a63",
  null
  
)

export default component.exports